// extracted by mini-css-extract-plugin
export default {"container":"layout_container__+tgCy"};